// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import HomePage from "../pages/Home/Home";
const __wvcRoutePaths = ["/", "/HomePage", "/home-page"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["about-us", "aboutuspage", "blog", "blogpage", "brickwork-services", "brickwork-services-balham", "brickwork-services-battersea", "brickwork-services-brixton", "brickwork-services-clapham", "brickwork-services-dulwich", "brickwork-services-norwood", "brickwork-services-peckham", "brickwork-services-richmond", "brickwork-services-streatham", "brickwork-services-wandsworth", "brickwork-services-wimbledon", "brickworkservicesbalhampage", "brickworkservicesbatterseapage", "brickworkservicesbrixtonpage", "brickworkservicesclaphampage", "brickworkservicesdulwichpage", "brickworkservicesnorwoodpage", "brickworkservicespage", "brickworkservicespeckhampage", "brickworkservicesrichmondpage", "brickworkservicesstreathampage", "brickworkserviceswandsworthpage", "brickworkserviceswimbledonpage", "contact-us", "contactuspage", "driveway-services-balham", "driveway-services-brixton", "driveway-services-clapham", "driveway-services-in-dulwich", "driveway-services-norwood", "driveway-services-peckham", "driveway-services-richmond", "driveway-services-south-london", "driveway-services-streatham", "driveway-services-wandsworth", "driveway-services-wimbledon", "drivewayservicesbalhampage", "drivewayservicesbrixtonpage", "drivewayservicesclaphampage", "drivewayservicesindulwichpage", "drivewayservicesrichmondpage", "drivewayserviceswandsworthpage", "drivewayserviceswimbledonpage", "drivewaysouthlondonpage", "drivewaysouthnorwoodpage", "drivewaysouthpeckhampage", "drivewaysouthstreathampage", "fencing-services", "fencing-services-balham", "fencing-services-battersea", "fencing-services-brixton", "fencing-services-clapham", "fencing-services-dulwich", "fencing-services-norwood", "fencing-services-peckham", "fencing-services-richmond", "fencing-services-streatham", "fencing-services-wandsworth", "fencing-services-wimbledon", "fencingservicesbalhampage", "fencingservicesbatterseapage", "fencingservicesbrixtonpage", "fencingservicesclaphampage", "fencingservicesdulwichpage", "fencingservicesnorwoodpage", "fencingservicespage", "fencingservicespeckhampage", "fencingservicesrichmondpage", "fencingservicesstreathampage", "fencingserviceswandsworthpage", "fencingserviceswimbledonpage", "gallery", "gallerypage", "garden-lighting-richmond", "garden-lighting-services", "garden-lighting-services-balham", "garden-lighting-services-battersea", "garden-lighting-services-brixton", "garden-lighting-services-clapham", "garden-lighting-services-dulwich", "garden-lighting-services-norwood", "garden-lighting-services-peckham", "garden-lighting-services-streatham", "garden-lighting-services-wandsworth", "garden-lighting-services-wimbledon-copy", "garden-room-services", "garden-room-services-balham", "garden-room-services-battersea", "garden-room-services-brixton", "garden-room-services-clapham", "garden-room-services-dulwich", "garden-room-services-norwood", "garden-room-services-peckham", "garden-room-services-streatham", "garden-room-services-wandsworth", "garden-room-services-wimbledon", "garden-rooms-richmond", "gardenlightingrichmondpage", "gardenlightingservicesbalhampage", "gardenlightingservicesbatterseapage", "gardenlightingservicesbrixtonpage", "gardenlightingservicesclaphampage", "gardenlightingservicesdulwichpage", "gardenlightingservicesnorwoodpage", "gardenlightingservicespage", "gardenlightingservicespeckhampage", "gardenlightingservicesstreathampage", "gardenlightingserviceswandsworthpage", "gardenlightingserviceswimbledoncopypage", "gardenroomservicesbalhampage", "gardenroomservicesbatterseapage", "gardenroomservicesbrixtonpage", "gardenroomservicesclaphampage", "gardenroomservicesdulwichpage", "gardenroomservicesnorwoodpage", "gardenroomservicespage", "gardenroomservicespeckhampage", "gardenroomservicesstreathampage", "gardenroomserviceswandsworthpage", "gardenroomserviceswimbledonpage", "gardenroomsrichmondpage", "home-page", "homepage", "locations", "locationspage", "patio-and-decking-services-balham", "patio-and-decking-services-battersea", "patio-and-decking-services-brixton", "patio-and-decking-services-clapham", "patio-and-decking-services-dulwich", "patio-and-decking-services-norwood", "patio-and-decking-services-peckham", "patio-and-decking-services-streatham", "patio-and-decking-services-wimbledon", "patio-decking-services", "patio-decking-services-richmond", "patio-decking-services-wandsworth", "patioanddeckingservicesbalhampage", "patioanddeckingservicesbatterseapage", "patioanddeckingservicesbrixtonpage", "patioanddeckingservicesclaphampage", "patioanddeckingservicesdulwichpage", "patioanddeckingservicesnorwoodpage", "patioanddeckingservicespeckhampage", "patioanddeckingservicesrichmondpage", "patioanddeckingservicesstreathampage", "patioanddeckingserviceswimbledonpage", "patiodeckingservicespage", "patiodeckingserviceswandsworthpage", "post", "services", "servicespage", "turfing-and-artificial-grass-services", "turfing-and-artificial-grass-services-balham", "turfing-and-artificial-grass-services-battersea", "turfing-and-artificial-grass-services-brixton", "turfing-and-artificial-grass-services-clapham", "turfing-and-artificial-grass-services-dulwich", "turfing-and-artificial-grass-services-norwood", "turfing-and-artificial-grass-services-peckham", "turfing-and-artificial-grass-services-streatham", "turfing-and-artificial-grass-services-wandsworth", "turfing-and-artificial-grass-services-wimbledon", "turfing-artificial-grass-services-richmond", "turfingandartificialgrassservicesbalhampage", "turfingandartificialgrassservicesbatterseapage", "turfingandartificialgrassservicesbrixtonpage", "turfingandartificialgrassservicesclaphampage", "turfingandartificialgrassservicesdulwichpage", "turfingandartificialgrassservicesnorwoodpage", "turfingandartificialgrassservicespage", "turfingandartificialgrassservicespeckhampage", "turfingandartificialgrassservicesrichmondpage", "turfingandartificialgrassservicesstreathampage", "turfingandartificialgrassserviceswandsworthpage", "turfingandartificialgrassserviceswimbledonpage", "water-feature-services", "water-feature-services-balham", "water-feature-services-battersea", "water-feature-services-brixton", "water-feature-services-clapham", "water-feature-services-dulwich", "water-feature-services-norwood", "water-feature-services-peckham", "water-feature-services-streatham", "water-feature-services-wandsworth", "water-feature-services-wimbledon", "water-features-richmond", "waterfeatureservicesbalhampage", "waterfeatureservicesbatterseapage", "waterfeatureservicesbrixtonpage", "waterfeatureservicesclaphampage", "waterfeatureservicesdulwichpage", "waterfeatureservicesnorwoodpage", "waterfeatureservicespage", "waterfeatureservicespeckhampage", "waterfeatureservicesstreathampage", "waterfeatureserviceswandsworthpage", "waterfeatureserviceswimbledonpage", "waterfeaturesrichmondpage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      <Route path={__wvcRoutePaths[0]} element={<HomePage />} />
      <Route path={__wvcRoutePaths[1]} element={<HomePage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[2]} element={<HomePage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
